import { get, post } from '@/utils/axios';

// 申诉列表 简单查询
export function getAppealOrderQuery(params) {
  return post('/bs/supplierAppeal/appealOrderQuery', params);
}

// 申诉详情 页面数据
export function getAppealDetail(params) {
  return get('/bs/supplierAppeal/appealDetail', params);
}

// 保存申诉信息
export function saveAppealInfo(params) {
  return post('/bs/supplierAppeal/appeal', params);
}

// 保存申诉信息
export function getAppealStatus(params) {
  return get('bs/supplierAppeal/enum/status', params);
}
